export default "__VITE_ASSET__Pu0tLjlt__"